export default "__VITE_ASSET__726e9ad1__"